import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ChangeDetectedItem from '../../../../template/ChangeDetectedItem/ChangeDetectedItem';
import CustomMassageBlock from './CustomMassageBlock';
import PreviewMassage from './PreviewMassage';
import { useChanges } from "../../../../../hooks/useChanges";
import { verificationApi } from '../../../../../http/Api'
import { getVerificationMessage } from '../../../../../store/Verification'

const CustomMassage = () => {
    const { changesDetected } = useSelector((state) => state.changeDetected);
    const { handleSaveChanges, cancelChanges } = useChanges();
    const { verificationMessageGlobalState } = useSelector((state) => state.verification);
    const [header, setHeader] = useState(verificationMessageGlobalState?.data?.embeds[0] || 'Header')
    const [title, setTitle] = useState(verificationMessageGlobalState?.data?.embeds[1] || 'Title')
    const [massage, setMassage] = useState(verificationMessageGlobalState?.data?.embeds[2] || 'Write your mesage here')

    return (
        <div className='setting_component_wrap'>
        <div className='overview_component_content_head'>
                <h4>Custom Embed Message</h4>
                <p>Prevent spam and malicious activity by monitoring and flagging suspicious user behaviour</p>
        </div>
        <div className='status_varification_content_wrap' style={{width:'100%'}}>
                <CustomMassageBlock
                title={title}
                setTitle={setTitle}
                massage={massage}
                setMassage={setMassage}
                header={header}
                setHeader={setHeader}
                data={verificationMessageGlobalState?.data}
                />
                <PreviewMassage
                    title={title}
                    setTitle={setTitle}
                    massage={massage}
                    setMassage={setMassage}
                    header={header}
                    setHeader={setHeader}
                    />
        </div>
        { changesDetected && <ChangeDetectedItem cancel={cancelChanges} onSave={()=>handleSaveChanges(verificationApi.updateVerificationMessage, getVerificationMessage)} />}
    </div>
    );
};

export default CustomMassage;